import { Car } from '@lib/azgaz-ui/connect';

const getCarPrice = (car: Car) => {
  const [price, specPrice] = car.price.value[0];
  return { price, specPrice };
};

export default getCarPrice;
